import { blue, blueDark, gray, grayDark, green, greenDark, red, redDark } from '@tamagui/colors';
// Keep relative imports for EAS build
import { Color, color } from '../../shared/utils/color';
import { contextColors as contextDark } from '../colors/dark/colors';
import { contextColors as contextLight } from '../colors/light/colors';

const PRESS = 0.2;
const COLOR_PRESS = 0.15;
const HOVER = 0.1;
const FOCUS = 0.1;
const BORDER = 0.05;

type ButtonTheme = {
  background: string;
  backgroundPress: string;
  backgroundHover: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorPress: string;
  borderColorHover: string;
  borderColorFocus: string;
  color: string;
  colorPress: string;
  colorHover: string;
  colorFocus: string;
};

const generateButtonTheme = (
  base: Color,
  isDark: boolean = false,
  overrides?: Partial<ButtonTheme>
): ButtonTheme => ({
  background: base.toCSSHex(),
  backgroundPress: base.darken(PRESS).toCSSHex(),
  backgroundHover: base.darken(HOVER).toCSSHex(),
  backgroundFocus: base.darken(FOCUS).toCSSHex(),
  borderColor: base.darken(BORDER).toCSSHex(),
  borderColorPress: base.darken(BORDER + PRESS).toCSSHex(),
  borderColorHover: base.darken(BORDER + HOVER).toCSSHex(),
  borderColorFocus: base.darken(BORDER + FOCUS).toCSSHex(),
  color: isDark ? dark_ButtonText.color : light_ButtonText.color,
  colorPress: isDark ? dark_ButtonText.colorPress : light_ButtonText.colorPress,
  colorHover: isDark ? dark_ButtonText.colorHover : light_ButtonText.colorHover,
  colorFocus: isDark ? dark_ButtonText.colorFocus : light_ButtonText.colorFocus,
  ...overrides
});

//#region Light theme
// Primary
const light_ButtonText = {
  color: gray.gray1,
  colorPress: color(gray.gray1).darken(COLOR_PRESS).toCSSHex(),
  colorHover: color(gray.gray1).darken(HOVER).toCSSHex(),
  colorFocus: color(gray.gray1).darken(FOCUS).toCSSHex()
};

export const light_blue_Button = generateButtonTheme(color(blue.blue8));

export const light_unistocksAlt_Button = generateButtonTheme(
  color(contextLight.unistocksAlt),
  false
);
export const light_unistocksAlt_ButtonText = {
  color: light_ButtonText.color
};

export const light_red_Button = generateButtonTheme(color(contextLight.danger), false, {
  color: red.red1,
  colorPress: color(red.red1).darken(COLOR_PRESS).toCSSHex()
});

export const light_green_Button = generateButtonTheme(color(contextLight.success), false, {
  color: green.green1,
  colorPress: color(green.green1).darken(COLOR_PRESS).toCSSHex()
});

//#endregion

//#region Dark theme
// Primary
const dark_ButtonText = {
  color: grayDark.gray12,
  colorPress: color(grayDark.gray12).darken(COLOR_PRESS).toCSSHex(),
  colorHover: color(grayDark.gray12).darken(HOVER).toCSSHex(),
  colorFocus: color(grayDark.gray12).darken(FOCUS).toCSSHex()
};

export const dark_blue_Button = generateButtonTheme(color(blueDark.blue4), true);

export const dark_unistocksAlt_Button = generateButtonTheme(color(contextDark.unistocksAlt), true);
export const dark_unistocksAlt_ButtonText = {
  color: dark_ButtonText.color
};

export const dark_red_Button = generateButtonTheme(color(contextDark.danger), true, {
  color: redDark.red12,
  colorPress: color(redDark.red12).darken(COLOR_PRESS).toCSSHex()
});

export const dark_green_Button = generateButtonTheme(color(contextDark.success), true, {
  color: greenDark.green12,
  colorPress: color(greenDark.green12).darken(COLOR_PRESS).toCSSHex()
});
//#endregion
